import request from "./../utils/request";

export function getUserInfo(id) {
    return request({
        url: `/users/${id}`,
        method: "get",
    });
}

export function loadOldConversations(visitorId) {
    return request({
        url: `/visitors/${visitorId}/conversations`,
        method: "get",
    });
}

export function addNoteToConversation(conversationId, representativeNote, representativeName) {
    return request({
        url: `/conversations/${conversationId}/note`,
        method: "post",
        data: {
            representativeName,
            representativeNote,
        },
    });
}

export function loadOldConversationsAsPaged(visitorId, page, perPage, conversationId) {
    if (conversationId)
        return request({
            url: `/visitors/${visitorId}/conversations-paged?page=${page}&perpage=${perPage}&conversationId=${conversationId}`,
            method: "get",
        });
    return request({
        url: `/visitors/${visitorId}/conversations-paged?page=${page}&perpage=${perPage}`,
        method: "get",
    });
}

export function loadOldMessages(conversationId) {
    return request({
        url: `/conversations/${conversationId}/messages`,
        method: "get",
    });
}
